export default {
	bidCount: {
		plural: '{bidCount} bids',
		singular: '{bidCount} bid',
	},
};
